import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../LandingPage';



function Router() {

  // return (
  //   <LandingPage/>
  // )
    return (         
       <Routes>         
         <Route path="*" Component={LandingPage}  />    
       </Routes>        
      );
}

export default Router;